import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import axios from 'axios'; // Import axios for HTTP requests

const ImportCustomerDetails = () => {
  const navigate = useNavigate();
  const [selectedFile, setSelectedFile] = useState(null);
  const [loading, setLoading] = useState(false); // Loading state

  // Function to handle file selection
  const handleFileChange = (event) => {
    setSelectedFile(event.target.files[0]);
  };

  // Function to handle the back action
  const handleBack = () => {
    navigate(-1); // Navigate back to the previous screen
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    
    if (selectedFile) {
      const formData = new FormData();
      formData.append('file', selectedFile);
      
      setLoading(true); // Start loading
      
      try {
        const response = await fetch('https://citi-mobile-app.onrender.com/admin/upload-customers', {
          method: 'POST',
          body: formData
        });
        
        const result = await response.json();
        console.log('Server response:', result);
        setLoading(false); // Stop loading after successful upload
      } catch (error) {
        console.log('Error uploading file:', error);
        setLoading(false); // Stop loading on error
      }
    } else {
      console.log('No file selected.');
    }
  };
  

  return (
    <div className="p-6 ml-60 max-sm:ml-0 max-sm:mt-16 max-sm:p-0 max-w-1/2 max-sm:w-full">
      {/* Back Icon */}
      <div className="flex items-center mb-4 cursor-pointer" onClick={handleBack}>
        <FontAwesomeIcon icon={faArrowLeft} className="text-gray-600 mr-2" />
        <span className="text-gray-600">Import Customer details</span>
      </div>

      {/* File Upload Form */}
      <form onSubmit={handleSubmit} className="bg-white p-6 shadow-md rounded">
        {/* File Upload Box */}
        <div className="mb-6 border-dashed border-2 border-gray-300 rounded-lg h-40 flex items-center justify-center">
          {selectedFile ? (
            <p>{selectedFile.name}</p>
          ) : (
            <label htmlFor="file-upload" className="cursor-pointer">
              <div className="text-gray-500">
                <p className="mb-2">Add file</p>
                <input
                  id="file-upload"
                  type="file"
                  onChange={handleFileChange}
                  className="hidden"
                />
              </div>
            </label>
          )}
        </div>

        {/* Action Buttons */}
        <div className="flex justify-between items-center">
          <button
            type="button"
            onClick={handleBack}
            className="bg-gray-300 text-gray-700 py-2 px-4 rounded hover:bg-gray-400"
          >
            Cancel
          </button>
          <button
            type="submit"
            disabled={loading} // Disable button when loading
            className={`py-2 px-4 rounded text-white ${
              loading ? 'bg-gray-400' : 'bg-blue-500 hover:bg-blue-600'
            }`}
          >
            {loading ? 'Uploading...' : 'Upload and preview'}
          </button>
        </div>
      </form>
    </div>
  );
};

export default ImportCustomerDetails;
